export default () => {
  let instaItems = document.querySelectorAll('.js-instagram');

  instaItems.forEach(item => {
    let username = item.getAttribute('data-username');
    let quantity = item.getAttribute('data-length') || 4;

    fetch(`https://www.instagram.com/${username}/?__a=1`)
      .then(res => res.json())
      .then(data => {
        let counter = data.graphql.user.edge_owner_to_timeline_media.edges.length;

        if (counter >= quantity) { counter = quantity }

        for (let i = 0; i < counter; i++) {
          let instaPost = data.graphql.user.edge_owner_to_timeline_media.edges[i].node;
          let thumbnail = instaPost.thumbnail_src;
          let url       = `https://www.instagram.com/p/${instaPost.shortcode}`;

          let insta = document.createElement('div');
          insta.setAttribute('id', instaPost.shortcode);

          let link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('target', '_blank');
          link.setAttribute('class', 'instagram__post');

          let instaImage = document.createElement('img');
          instaImage.setAttribute('src', thumbnail);

          link.append(instaImage);
          insta.append(link);

          item.append(link)
        }
      });
  });
}
